export default __webpack_public_path__ + "static/media/applaus-logo-white.01503b1c.png";